import UserDetails from "crqlar-react-common/dist/components/user/UserDetails";
import {useNavigate} from "react-router-dom";
import SettingsEntityHeader from "./SettingsEntityHeader";

const SettingsUserDetails = () => {
    const navigate = useNavigate()

    return (
        <UserDetails
            adminAccess={false}
            renderHeader={({title, data, restrictEdit}) => (
                <SettingsEntityHeader
                    title={title}
                    back={() => navigate('/system/team')}
                    data={data}
                    restrictEdit={restrictEdit}
                />
            )}
        />
    )
}

export default SettingsUserDetails
